export default __webpack_public_path__ + "static/fish-map-82e64a47ae1c9c150701097a92dc1e33.svg";